import type { LocalUser } from "~/shared/types/auth";
export function useUser() {
  return useState<LocalUser | null>("local-user", () => null);
}
